import { Environments } from '@/config';
import { WAKEMED_PRODUCTION } from './wakemed.production';
import { WAKEMED_STAGING } from './wakemed.staging';

export const WAKEMED = import.meta.env.MODE === Environments.PROD ? WAKEMED_PRODUCTION : WAKEMED_STAGING;
